import { render, staticRenderFns } from "./UnitPrice.vue?vue&type=template&id=1a653888&"
import script from "./UnitPrice.vue?vue&type=script&lang=js&"
export * from "./UnitPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports